import { render } from "./AppCertification.vue?vue&type=template&id=2ca6094a&scoped=true"
import script from "./AppCertification.vue?vue&type=script&lang=js"
export * from "./AppCertification.vue?vue&type=script&lang=js"

import "./AppCertification.vue?vue&type=style&index=0&id=2ca6094a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca6094a"]])

export default __exports__